export const state = {
  modeloTanque: {},
  modelosTanques: [],
  modalExcluirModeloTanque: false,
  modalCadastroModeloTanque: false,
};

export default {};
